export const HERO_SURFACE = {
  bgLight:     'linear-gradient(140deg, #F7F5FF 0%, #E9E4FF 55%, #DDD7F8 100%)',
  bgDark:      'linear-gradient(140deg, #171620 0%, #242035 55%, #1D1A29 100%)',
  borderLight: 'none',
  borderDark:  'none',
  shadowLight: 'none',
  shadowDark:  'none',
}

// 수강신청 허브("새벽 궤도")와 같은 팔레트 — 깊은 네이비 바탕 + 웜 오렌지(--rh-dawn) 포인트.
// 개강 전 홈 Hero(RegistrationHeroCard)가 허브와 같은 제품처럼 보이도록 이 값을 그대로 가져온다.
export const REGISTRATION_HERO_SURFACE = {
  bgLight:     'linear-gradient(135deg, #FBF6F2 0%, #F7ECE5 55%, #F3E5DC 100%)',
  bgDark:      'linear-gradient(135deg, #1F1918 0%, #29201D 55%, #31241F 100%)',
  borderLight: 'none',
  borderDark:  'none',
  shadowLight: 'none',
  shadowDark:  'none',
  ctaLight:    'linear-gradient(135deg, #d9723f 0%, #c65420 55%, #a8451a 100%)',
  ctaDark:     'linear-gradient(135deg, #d9723f 0%, #c65420 55%, #9c3f18 100%)',
}
